import { render, staticRenderFns } from "./201.vue?vue&type=template&id=40147b38&scoped=true"
import script from "./201.vue?vue&type=script&lang=js"
export * from "./201.vue?vue&type=script&lang=js"
import style0 from "./201.vue?vue&type=style&index=0&id=40147b38&prod&lang=less&scoped=true"
import style1 from "./201.vue?vue&type=style&index=1&id=40147b38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40147b38",
  null
  
)

export default component.exports